import { useEffect, useState } from "react";
import { useAppSelector } from "../../../../hooks";
import { selectPermissions } from "../../../../features/permissionsSlice";
import { CustomizeTargetingModal } from "../../modal";
import { SettingsIcon } from "../../../images";
import { ButtonsType, CampaignPurpose } from "../../../../types/enums";
import { ReuseButton } from "components/ui/ReuseButton";
import {
  useGetCampaignFieldsQuery,
  useGetCampaignSummaryQuery,
  useLazyGetTargetingConfigurationQuery,
} from "../../../../api";
import { CircularProgress } from "@mui/material";
import { toast } from "react-toastify";
import { CustomToast } from "../../CustomToast";
import { getErrorMessage } from "../../../../utils/getErrorMessage";

type Props = {
  campaign_id: string;
};
export const CustomizeTargetingBtn = ({ campaign_id }: Props) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isAllowedEditResyncData } = useAppSelector(selectPermissions);

  const [getTargetingConfiguration, { currentData, isFetching }] =
    useLazyGetTargetingConfigurationQuery();

  const { data: summary } = useGetCampaignSummaryQuery({
    campaign_id: campaign_id!,
  });

  const isDemo = summary?.campaign_purpose !== CampaignPurpose.base;

  const {
    data: campaignFieldsData,
    isError,
    error,
    isFetching: isFieldsFetching,
  } = useGetCampaignFieldsQuery();

  useEffect(() => {
    if (isError && error) {
      toast.error(
        <CustomToast
          type="error"
          text={
            getErrorMessage(error).globalError ||
            "Something went wrong. Please try again"
          }
          title="Failed to Fetch Campaign Fields"
        />,
      );
    }
  }, [isError]);

  const openModal = () => {
    getTargetingConfiguration({ campaign_id })
      .unwrap()
      .then(() => setIsOpen(true));
  };
  const closeModal = () => setIsOpen(false);

  return (
    <>
      <ReuseButton
        onClick={openModal}
        startIcon={
          isFetching || isFieldsFetching ? (
            <CircularProgress color={"inherit"} size={20} />
          ) : (
            <SettingsIcon />
          )
        }
        disabled={!isAllowedEditResyncData || isFetching || isDemo}
        buttonType={ButtonsType.text}
      >
        Customize Targeting
      </ReuseButton>
      {isOpen && currentData && campaignFieldsData && (
        <CustomizeTargetingModal
          campaign_id={campaign_id}
          currentTargeting={currentData}
          campaignFieldsData={campaignFieldsData}
          onClose={closeModal}
        />
      )}
    </>
  );
};
